import moment from 'moment';

/**
 * 숫자만 입력 가능
 * --
 * @param {string} value
 * @returns {string}
 */
const formatNumberOnly = (value, type = 'int') => {
  if (type === 'int') {
    return value.replace(/[^0-9]/g, '');
  } else if (type === 'hyphen') {
    return value.replace(/[^0-9-]/g, '');
  } else {
    // double
    return value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
  }
};

/**
 * 한글 입력 제한
 * --
 * @param {string} value
 * @returns {string}
 */
const formatRestrictKorean = (value) => {
  return value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '');
};
/**
 * 자동 하이픈
 * --
 * @param {string | number} value
 * @param {string} type
 * @param {boolean} allowString
 * @returns
 */
const formatHyphen = (value, type = 'phone', allowString = false) => {
  let str = allowString ? value : value.replace(/[^0-9]/g, ''); // 숫자만 남기기

  // 휴대폰
  if (type === 'phone') {
    if (str.startsWith('02')) {
      if (str.length > 2 && str.length <= 5) {
        str = str.slice(0, 2) + '-' + str.slice(2);
      } else if (str.length > 5 && str.length <= 9) {
        str = str.slice(0, 2) + '-' + str.slice(2, 5) + '-' + str.slice(5);
      } else if (str.length > 9) {
        str = str.slice(0, 2) + '-' + str.slice(2, 6) + '-' + str.slice(6, 10);
      }
    } else {
      if (str.length > 3 && str.length <= 6) {
        str = str.slice(0, 3) + '-' + str.slice(3);
      } else if (str.length > 6 && str.length <= 10) {
        str = str.slice(0, 3) + '-' + str.slice(3, 6) + '-' + str.slice(6);
      } else if (str.length > 10) {
        str = str.slice(0, 3) + '-' + str.slice(3, 7) + '-' + str.slice(7, 11);
      }
    }
  }
  // 사업자등록번호
  else if (type === 'business_num') {
    if (str.length > 3 && str.length <= 5) {
      str = str.slice(0, 3) + '-' + str.slice(3);
    } else if (str.length > 5 && str.length <= 10) {
      str = str.slice(0, 3) + '-' + str.slice(3, 5) + '-' + str.slice(5);
    } else if (str.length > 10) {
      str = str.slice(0, 3) + '-' + str.slice(3, 5) + '-' + str.slice(5, 10);
    }
  }
  // 카드번호
  else if (type === 'card') {
    if (str.length > 4 && str.length <= 8) {
      str = str.slice(0, 4) + '-' + str.slice(4);
    } else if (str.length > 8 && str.length <= 12) {
      str = str.slice(0, 4) + '-' + str.slice(4, 8) + '-' + str.slice(8);
    } else if (str.length > 12) {
      str =
        str.slice(0, 4) +
        '-' +
        str.slice(4, 8) +
        '-' +
        str.slice(8, 12) +
        '-' +
        str.slice(12);
    }
  }

  return str;
};

/**
 * 유닉스 타임을 Date 형식으로 변환
 * --
 * @param {number} unix
 * @param {string} format
 * @returns
 */
const formatUnixToDate = (unix, format = '', locale = 'ko') => {
  const unixTime = unix * 1000;

  moment.locale(locale);

  const formattedDate = !format
    ? new Date(unixTime)
    : moment(unixTime).format(format);

  // 한국어로 초기화
  if (locale !== 'ko') {
    moment.locale('ko');
  }

  return formattedDate;
};

/**
 * Date 형식을 유닉스 타임으로 변환
 * --
 * @param {string} date
 * @returns
 */
const formatDateToUnix = (date = new Date()) => {
  const unix = new Date(date).getTime() / 1000;

  return Math.floor(unix);
};

/**
 * 멤버십 코드 포멧
 * --
 * @param {string} code
 * @returns
 */
const formatMemberShipCode = (code) => {
  let str = code;

  if (!str) return;

  if (str.length > 4 && str.length <= 8) {
    str = str.slice(0, 4) + '-' + str.slice(4);
  } else if (str.length > 8 && str.length <= 12) {
    str = str.slice(0, 4) + '-' + str.slice(4, 8) + '-' + str.slice(8);
  } else if (str.length > 12) {
    str =
      str.slice(0, 4) +
      '-' +
      str.slice(4, 8) +
      '-' +
      str.slice(8, 12) +
      '-' +
      str.slice(12);
  }

  return str;
};

const formatMaskingNumber = (value, type = 'card') => {
  let str = value.replace(/[^0-9]/g, ''); // 숫자만 남기기

  // 카드 번호 마스킹
  if (type === 'card') {
    if (value.length > 4 && value.length <= 8) {
      str = str.slice(0, 4) + '*'.repeat(value.length - 4);
    } else if (value.length > 8 && str.length <= 12) {
      str = str.slice(0, 4) + '****' + '*'.repeat(value.length - 8);
    } else if (value.length > 12) {
      str = str.slice(0, 4) + '********' + str.slice(4);
    }
    // 4자리 단위로 공백 추가
    return str.replace(/(.{4})(?=.)/g, '$1 ').trim();
  }

  return str;
};

const Formatter = {
  hyphen: formatHyphen,
  unixToDate: formatUnixToDate,
  dateToUnix: formatDateToUnix,
  membership: formatMemberShipCode,
  numberOnly: formatNumberOnly,
  restrictKorean: formatRestrictKorean,
  maskingNumber: formatMaskingNumber,
};

export default Formatter;
